import Glide from '@glidejs/glide';

import '@glidejs/glide/dist/css/glide.core.css';
import '@glidejs/glide/dist/css/glide.theme.css';

document.addEventListener('DOMContentLoaded', () => {

		let cardSliders = document.querySelectorAll('[data-template="card-slider"] .glide');

		if (cardSliders) {
			cardSliders.forEach(
				(el) => {
					new Glide(
						el,
						{
							type: 'carousel',
							perView: 3,
							gap: 90,
							focusAt: 1,
							bound: true,
							breakpoints: {
								1470: {
									perView: 3,
									gap: 60,
								},
								1023: {
									perView: 2,
									gap: 40,
									focusAt: 'center',
								},
								767: {
									perView: 2,
									gap: 40,
									focusAt: 'center',
								},
								639: {
									perView: 1,
									gap: 30,
									peek: {
										before: 60,
										after: 60,
									},
								},
							},
						}
					)
						.mount();
				}
			)
		}

		let videoSliders = document.querySelectorAll('.glide[data-template="video-slider"]');

		if (videoSliders) {
			videoSliders.forEach(
				(el) => {
					new Glide(
						el,
						{
							type: 'carousel',
							perView: 1,
							gap: 0,
							bound: true,
						}
					)
						.mount();
				}
			);
		}

		let defaultSliders = document.querySelectorAll('.glide[data-slider="default"]');

		if (defaultSliders) {
			defaultSliders.forEach(
				(el) => {
					new Glide(
						el,
						{
							type: 'carousel',
						}
					).mount();
				}
			)
		}

	}
);